export enum BypassCode {
  IDENTITY_COMPARISON_FAIL = 'IDENTITY_COMPARISON_FAIL',
  SCAN_PASSPORT_FAIL = 'SCAN_PASSPORT_FAIL',
  SCAN_GOVERNMENT_ID_FAIL = 'SCAN_GOVERNMENT_ID_FAIL',
  EXPORT_CONTROL_VALIDATION = 'EXPORT_CONTROL_VALIDATION',
  IDENTITY_POLICY_DECLINED = 'IDENTITY_POLICY_DECLINED',
  NO_IDENTITY_DOCUMENT = 'NO_IDENTITY_DOCUMENT',
}
